import { useCallback, useEffect, useState } from 'react';
import { fetchAdminHiddenPointsHoneypot } from '../infrastructure/adminApi';

const formatDate = (value) => new Date(value).toLocaleString('es-MX', {
  dateStyle: 'medium', timeStyle: 'short',
});

export default function HiddenPointsHoneypotPanel({ authorization, onSessionExpired }) {
  const [hits, setHits] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const result = await fetchAdminHiddenPointsHoneypot(authorization);
      setHits(result.hits || []);
    } catch (requestError) {
      if (requestError.status === 401) onSessionExpired?.();
      else setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }, [authorization, onSessionExpired]);

  useEffect(() => { load(); }, [load]);

  return (
    <section className="mx-auto max-w-[1480px] px-5 pb-8 lg:px-8">
      <div className="border border-[#312a3a] bg-[#121019]/80 p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h3 className="font-display text-2xl uppercase text-white">Señuelos de puntos ocultos</h3>
            <p className="mt-1 text-xs leading-5 text-[#afa2b9]">
              Intentos de activar puntos invisibles. Son indicios para revisar; no bloquean ni descuentan puntos.
            </p>
          </div>
          <button type="button" onClick={load} disabled={loading}
            className="min-h-[44px] border border-[#594a65] px-4 py-2 text-xs text-white disabled:opacity-50">
            {loading ? 'Cargando…' : 'Actualizar'}
          </button>
        </div>
        {error && <p className="mt-4 text-sm text-[#ffd8de]" role="alert">{error}</p>}
        {!loading && !error && hits.length === 0 && (
          <p className="mt-4 text-sm text-[#afa2b9]">Sin activaciones registradas.</p>
        )}
        {hits.length > 0 && (
          <div className="mt-4 overflow-x-auto">
            <table className="w-full min-w-[520px] text-left text-xs text-[#eee8f5]">
              <thead className="border-b border-[#3a3344] text-[#afa2b9]">
                <tr><th className="px-3 py-2">Jugador</th><th className="px-3 py-2">Señuelo</th>
                  <th className="px-3 py-2">Intentos</th><th className="px-3 py-2">Última vez</th></tr>
              </thead>
              <tbody>
                {hits.map((hit) => (
                  <tr key={hit.id} className="border-b border-[#26202d]">
                    <td className="px-3 py-2">{hit.username} (#{hit.playerId})</td>
                    <td className="px-3 py-2 font-mono">{hit.pointId}</td>
                    <td className="px-3 py-2">{hit.attempts}</td>
                    <td className="px-3 py-2">{formatDate(hit.lastAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
